import { useTranslation } from '@packages/utils';
import { TSectionProps } from 'components/Base/Layout/Content/SectionsContent/SectionsContent.types';
import SectionsContent from 'components/Base/Layout/Content/SectionsContent';
import ReadOnlyWrapper from 'components/Base/ReadOnlyWrapper';
import BasicInfo from './BasicInfo';
import Description from './Description';
import { TDetailsTabProps } from './DetailsTab.types';

const DetailsTab = ({
  data,
  id,
  isFetching,
  canEdit = true,
}: TDetailsTabProps) => {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  const sectionsInfo: TSectionProps[] = [
    {
      id: 1,
      title: t(`enums.event-type.${data.type}`),
      content: (
        <ReadOnlyWrapper isReadOnly={!canEdit}>
          <BasicInfo
            event={data}
            id={id}
            isFetchingEventData={isFetching}
            canEdit={canEdit}
          />
        </ReadOnlyWrapper>
      ),
    },
    {
      id: 2,
      title: t('descriptions.admin-portal.events.details.description.LABEL'),
      content: (
        <ReadOnlyWrapper isReadOnly={!canEdit}>
          <Description id={id} description={data?.description} />
        </ReadOnlyWrapper>
      ),
    },
  ];

  return <SectionsContent sections={sectionsInfo} />;
};

export default DetailsTab;
